<p class="assessment-title">Vurdering av mobil</p>
<p>
  Selv om kunden har oppgitt at mobilen er uten skader, gjør vi en vurdering for å sikre at alt stemmer. Hvis vi finner noe,
  kan kunden bli fakturert for differansen mellom innbytteverdi og mobilens faktiske tilstand. Vi kontakter kunden dersom vi
  finner noen skader.
</p>
<app-ice-checkbox
  forId="is-customer-informed"
  label="Kunden er informert om dette"
  ngDefaultControl
  testId="is-customer-informed-input"
  [errorOnTouchedOnly]="true"
  [formControl]="isCustomerInformed"
/>
